<template>
  <div class="app-main__inner">
    <TituloComponent
      icono-titulo="fas fa-pencil-alt"
      texto-titulo="Editar Modalidad"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarModalidadContratacion()">
          <float-label label="Código:" clase>
            <input
              v-model="modalidadContratacion.codigo"
              id="codigo"
              placeholder="Ingresar un código..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.modalidadContratacion.codigo.required ? 'is-invalid' : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.modalidadContratacion.codigo.required"
              >
                Debe ingresar un código
              </div>
            </template>
          </float-label>
          <float-label label="Descripción:" clase>
            <input
              v-model="modalidadContratacion.descripcion"
              id="descripcion"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.modalidadContratacion.descripcion.required
                  ? 'is-invalid'
                  : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.modalidadContratacion.descripcion.required"
              >
                Debe ingresar una descripción
              </div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import Swal from "sweetalert2";
import ModalidadContratacion from "@/models/modalidadContratacion";
import FloatLabel from "@/components/layouts/FloatLabel";
export default {
  name: "EditarModalidadContratacion",
  components: {
    TituloComponent,
    FloatLabel,
  },
  data() {
    return {
      modalidadContratacion: new ModalidadContratacion(null, "", ""),
      loading: false,
      enviado: false,
    };
  },
  validations: {
    modalidadContratacion: {
      codigo: { required },
      descripcion: { required },
    },
  },
  mounted() {
    this.modalidadContratacion.id = this.$route.params.id;
    this.getModalidadContratacion();
  },
  methods: {
    getModalidadContratacion() {
      this.loading = true;
      axios
        .get("modalidadcontratacion/" + this.modalidadContratacion.id)
        .then((res) => {
          console.log(res.data);
          console.log(res.data.modalidadcontratacion);
          if (res.data.success) {
            this.modalidadContratacion = res.data.modalidadcontratacion;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado modalidades.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarModalidadContratacion() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      console.log("entra a modalidad contratacion");
      axios
        .put(
          "/modalidadcontratacion/" + this.modalidadContratacion.id,
          this.modalidadContratacion
        )
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.modalidadcontratacion.descripcion} se editó con éxito.`,
            });
            this.$router.push({ name: "ListarModalidadContrataciones" });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>